import {
  LOCATION_CHANGE,
  CALL_HISTORY_METHOD
} from 'connected-react-router/lib/actions';
import {checkFlux} from './fluxes';
import {resetFlux} from '../actions/fluxes';
import {hasNoSteps} from '../reducers/fluxes';

/**
 * This middleware captures navigation events and first page loads and checks both data constraints
 * and navigation fluxes
 */
const navigationFluxesMiddleware = history => store => next => action => {
  if (action.type !== LOCATION_CHANGE && action.type !== CALL_HISTORY_METHOD) {
    return next(action);
  }

  const state = store.getState();
  const currentLocation = state.getIn(['router', 'location', 'pathname']);

  let location;
  if (action.type === LOCATION_CHANGE) {
    location = action.payload.location.pathname;
  } else if (action.type === CALL_HISTORY_METHOD) {
    location = action.payload.args[0];
  }

  if (!checkFlux(currentLocation, location) && !hasNoSteps(state)) {
    store.dispatch(resetFlux());
  }

  next(action);
};

export default navigationFluxesMiddleware;
